function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import React, { useMemo } from 'react';
import clsx from 'clsx';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { InputReact } from 'common/components/input';
import { InputSize, ValidationStatus } from 'common/components/input/types';
import { WINDOW_LENGTH_UNITS, WindowLengthUnit, WindowType } from 'common/types/reports/query';
import { capitalize, pluralize } from 'common/util/string';
import { ButtonReact } from 'common/components/button';
import { withStyles } from 'common/util/react';
import { useStagedState } from 'common/hooks/useStagedState';
import { parseNumber } from 'common/util';
import css from './index.module.styl?inline';
import styles from './index.module.styl';
const DEFAULT_LENGTH = 7;
const DEFAULT_LENGTH_UNIT = WindowLengthUnit.DAY;
type LookbackWindow = {
  windowLength?: number;
  windowLengthUnit?: WindowLengthUnit;
  windowType?: WindowType;
};
export const BehavioralLookbackWindowSubItem = withStyles((props: {
  className?: string;
  lookbackWindow: LookbackWindow;
  open: boolean;
  onChange: (window: LookbackWindow) => void;
  onOpen: () => void;
  onClose: () => void;
}) => {
  var _props$lookbackWindow, _props$lookbackWindow2;
  const [stagedLookbackWindow, setStagedLookbackWindow] = useStagedState(props.lookbackWindow, props.onChange);
  const invalidText = useMemo(() => {
    const {
      windowLength
    } = stagedLookbackWindow;
    if (windowLength <= 0) {
      return "Time must be an integer value.";
    }
    if (windowLength > 90) {
      return "Time exceeds 90 day limit.";
    }
    return "";
  }, [stagedLookbackWindow]);
  return <SelectReact className={clsx(styles.subitemSelect, props.className)} label={"".concat((_props$lookbackWindow = props.lookbackWindow.windowLength) !== null && _props$lookbackWindow !== void 0 ? _props$lookbackWindow : DEFAULT_LENGTH, " ").concat((_props$lookbackWindow2 = props.lookbackWindow.windowLengthUnit) !== null && _props$lookbackWindow2 !== void 0 ? _props$lookbackWindow2 : DEFAULT_LENGTH_UNIT, "s")} open={props.open} theme={SelectTheme.QbSubitem} size={ButtonSize.Small} preventClose onMenuChange={ev => {
    if (ev.detail.isOpen) {
      props.onOpen();
    } else {
      props.onClose();
    }
  }}>
        {props.open && <div className={styles.windowSelectionContainer} slot='body'>
            <div className={styles.windowSelectionInputs}>
              <InputReact className={styles.windowLengthInput} helpText='The amount of time to calculate the behavior after the birth event' type='number' size={InputSize.Medium} validationStatus={invalidText ? ValidationStatus.Invalid : ValidationStatus.Default} value={stagedLookbackWindow.windowLength !== null ? stagedLookbackWindow.windowLength.toString() : ""} onInput={ev => setStagedLookbackWindow(_objectSpread(_objectSpread({}, stagedLookbackWindow), {}, {
          windowLength: parseNumber(ev.target.value)
        }))} />
              <SelectReact className={styles.windowLengthUnitInput} elref='windowLengthUnit' disableSearch sections={[{
          items: WINDOW_LENGTH_UNITS.map(unit => ({
            value: unit,
            label: capitalize(pluralize(unit, true)),
            isSelected: unit === stagedLookbackWindow.windowLengthUnit
          }))
        }]} selectedOption={capitalize(pluralize(stagedLookbackWindow.windowLengthUnit, true))} theme={SelectTheme.Tertiary} neverShowCaret tooltip={{
          text: "Time Unit to be applied to the Window Length value"
        }} onChange={ev => setStagedLookbackWindow(_objectSpread(_objectSpread({}, stagedLookbackWindow), {}, {
          windowLengthUnit: ev.detail.item.value
        }))} />
            </div>
            {!!invalidText && <div className={styles.windowSelectionErrorMessage}>{invalidText}</div>}
            <div className={styles.windowSelectionFooter}>
              <ButtonReact className={styles.resetButton} elref='resetButton' theme={ButtonTheme.Tertiary} disabled={stagedLookbackWindow.windowLength === DEFAULT_LENGTH && stagedLookbackWindow.windowLengthUnit === DEFAULT_LENGTH_UNIT} onClick={() => setStagedLookbackWindow({
          windowLength: DEFAULT_LENGTH,
          windowLengthUnit: DEFAULT_LENGTH_UNIT
        })}>
                Reset
              </ButtonReact>
              <div className={styles.coreBtnGroup}>
                <ButtonReact theme={ButtonTheme.Tertiary} elref='cancelButton' onClick={props.onClose}>
                  Cancel
                </ButtonReact>
                <ButtonReact className={styles.applyButton} theme={ButtonTheme.Primary} disabled={!!invalidText} elref='applyButton' onClick={() => {
            var _props$onChange;
            return (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, _objectSpread(_objectSpread({}, stagedLookbackWindow), {}, {
              windowType: WindowType.AFTER
            }));
          }}>
                  Apply
                </ButtonReact>
              </div>
            </div>
          </div>}
      </SelectReact>;
}, css);